// src/lib/utils.ts
// Utility functions for classnames and more

// Enhanced cn utility: supports string, falsy, and object syntax like classnames
export function cn(...args: Array<string | undefined | null | false | Record<string, boolean>>): string {
  return args
    .flatMap(arg => {
      if (!arg) return [];
      if (typeof arg === 'string') return [arg];
      if (typeof arg === 'object') {
        return Object.entries(arg)
          .filter(([, v]) => !!v)
          .map(([k]) => k);
      }
      return [];
    })
    .join(' ');
}
